import { TitlePageCartoEdit } from 'components/TitlePageCartoEdit/TitlePageCartoEdit';
import { FC } from 'react';
import { PageCartoChartPanel } from './PageCartoChartPanel/PageCartoChartPanel';
import { PageCartoMap } from './PageCartoMap';
import { PageCartoPanels } from './PageCartoPanels';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from 'components/ui/resizable';

export const PageCartoEditor: FC = () => {
  return (
    <ResizablePanelGroup
      className="h-full"
      style={{ height: 'calc(100% - 64px)' }}
      direction="horizontal"
      autoSaveId="page-carto-editor-layout"
    >
      <ResizablePanel defaultSize={50} minSize={30} className="min-h-0 p-2">
        <div className="relative flex h-full flex-1 overflow-hidden">
          <div className="absolute z-50 flex w-full bg-white bg-opacity-50 p-2">
            <TitlePageCartoEdit />
          </div>
          <PageCartoMap canEdit={true} />
          <div className="absolute bottom-0 right-0 z-50 mb-2 w-[50%] opacity-90">
            <PageCartoChartPanel />
          </div>
        </div>
      </ResizablePanel>
      <ResizableHandle withHandle />
      <ResizablePanel
        defaultSize={50}
        minSize={25}
        className="min-h-0 overflow-auto p-2"
      >
        <PageCartoPanels />
      </ResizablePanel>
    </ResizablePanelGroup>
  );
};
